import React, { useState } from "react";
import { FileSpreadsheet, FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { API } from "./api";
import { exportToPdf, PDF_MAX_ROWS } from "./exports";

const num2 = (v) => (v == null || v === "" ? "" : Math.round(Number(v) * 100) / 100);
const eurPdf = (v) => (v == null || v === "" ? "" : `${Number(v).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`);
const numPdf = (v) => (v == null || v === "" ? "" : Number(v).toLocaleString("es-ES", { maximumFractionDigits: 2 }));
const fecha = (v) => (v ? new Date(v).toLocaleDateString("es-ES") : "");

export const col = {
  text: (header, key) => ({ header, key }),
  eur: (header, key) => ({ header, key, format: num2, pdf: eurPdf, align: "right" }),
  num: (header, key) => ({ header, key, format: num2, pdf: numPdf, align: "right" }),
  pct: (header, key, factor = 100) => ({ header, key, align: "right",
    format: (v) => (v == null ? "" : Math.round(v * factor * 10) / 10),
    pdf: (v) => (v == null ? "" : `${(v * factor).toLocaleString("es-ES", { maximumFractionDigits: 1 })} %`) }),
  date: (header, key) => ({ header, key, format: fecha }),
};

export const PRODUCT_COLS = [
  col.text("CN", "cn"), col.text("Descripción", "descripcion"), col.text("Familia", "familia"),
  col.text("Laboratorio", "laboratorio"), col.num("Stock", "stock"), col.eur("PVP", "pvp"),
  col.num("Uds. vendidas", "uds_vendidas"), col.eur("Valor PVP", "valor_pvp"), col.eur("Ventas", "tot_venta"),
  col.date("Última compra", "u_entrada"), col.text("ABCD", "abcd"),
];

const clean = (f) => Object.fromEntries(Object.entries(f || {}).filter(([, v]) => v !== "" && v != null && v !== "all"));

/** Excel (todos los productos del filtro, desde el servidor) + PDF (los 500 primeros). */
export function ServerProductsExport({ studyId, filters, title, subtitle, filename, testIdPrefix, sortBy = "tot_venta", sortDir = "desc", columns = PRODUCT_COLS }) {
  const [busy, setBusy] = useState(false);
  const f = clean(filters);
  const excel = () => window.open(`${API}/studies/${studyId}/export/selection?${new URLSearchParams({ ...f, nombre: filename }).toString()}`, "_blank");
  const pdf = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/studies/${studyId}/products`, { params: { ...f, limit: PDF_MAX_ROWS, sort_by: sortBy, sort_dir: sortDir } });
      exportToPdf({ filename, title, subtitle, columns, rows: data.items, totalRows: data.total, orientation: "landscape" });
    } catch { toast.error("No se pudo generar el PDF"); } finally { setBusy(false); }
  };
  return (
    <div className="inline-flex gap-2">
      <button type="button" onClick={excel} className="btn btn-outline btn-sm" data-testid={`${testIdPrefix}-excel-button`} title="Excel con todos los productos del filtro">
        <FileSpreadsheet size={14} /> Excel
      </button>
      <button type="button" onClick={pdf} disabled={busy} className="btn btn-outline btn-sm" data-testid={`${testIdPrefix}-pdf-button`} title={`PDF con los ${PDF_MAX_ROWS} primeros`}>
        {busy ? <Loader2 size={14} className="animate-spin" /> : <FileText size={14} />} PDF
      </button>
    </div>
  );
}
